module.exports = __webpack_public_path__ + "img/apple.68b06f41.svg";